import script from "./ProjectChatMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectChatMessages.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QInput});
